import { Link } from 'react-router-dom';
import { channels } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <h4 className="text-lg font-bold mb-4" style={{ fontFamily: 'var(--font-heading)' }}>麻花影视</h4>
              <p className="text-foreground-400 text-sm leading-relaxed">
                麻花影视汇集四虎影视、影视飓风、番茄影视、大叔影视等特色频道，为您提供高清流畅的在线观影体验。
              </p>
            </div>
            <div>
              <h4 className="text-sm font-semibold mb-4 text-foreground-300 uppercase tracking-wider">特色频道</h4>
              <ul className="space-y-2">
                {channels.slice(0, 5).map((ch) => (
                  <li key={ch.slug}>
                    <Link to={`/category/${ch.slug}`} className="text-foreground-400 hover:text-background-50 text-sm transition-colors whitespace-nowrap">
                      {ch.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold mb-4 text-foreground-300 uppercase tracking-wider">更多频道</h4>
              <ul className="space-y-2">
                {channels.slice(5).map((ch) => (
                  <li key={ch.slug}>
                    <Link to={`/category/${ch.slug}`} className="text-foreground-400 hover:text-background-50 text-sm transition-colors whitespace-nowrap">
                      {ch.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-semibold mb-4 text-foreground-300 uppercase tracking-wider">关于</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/about" className="text-foreground-400 hover:text-background-50 text-sm transition-colors whitespace-nowrap">关于我们</Link>
                </li>
                <li>
                  <Link to="/" className="text-foreground-400 hover:text-background-50 text-sm transition-colors whitespace-nowrap">精选推荐</Link>
                </li>
                <li>
                  <Link to="/" className="text-foreground-400 hover:text-background-50 text-sm transition-colors whitespace-nowrap">最新内容</Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-foreground-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-foreground-500 text-sm">&copy; 2026 麻花影视 - 高清影视在线观看平台</p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-foreground-400 hover:text-background-50 text-sm transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
              <a href="#" className="text-foreground-400 hover:text-background-50 text-sm transition-colors whitespace-nowrap" rel="nofollow">服务条款</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}